export default __webpack_public_path__ + "static/media/Maul of the Veiled Moon.9ac36d37.jpg";